import { JSX, useContext } from "react";
import {
    Button,
    Checkbox,
    Popup,
} from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
    setIsCheckboxChecked,
    setIsDeleteAccountModalOpen,
} from "../EmployeeInactiveSlice";
import { useDeleteEmployeeMutation } from "../../../common/api/employee";
import { handleDeleteEmployee } from "../utils/handleDeleteEmployee";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";
import { AuthContext } from "react-oauth2-code-pkce";

export const DeleteAccountConfirmationModal = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const authContext = useContext(AuthContext);
    const { isCheckboxChecked } = useAppSelector(
        (state) => state.employeeInactive,
    );
    const employeeId = useEmployeeId();
    const [deleteEmployee, { isLoading: deleteEmployeeIsLoading }] =
        useDeleteEmployeeMutation();

    return (
        <Popup
            className={"p-employee-inactive__content__popup"}
            onCloseClick={() => dispatch(setIsDeleteAccountModalOpen(false))}
        >
            <h2>Weet je het zeker?</h2>
            <p>
                Heb je al jouw certificaten gedownload en weet je zeker dat je
                jouw account permanent wilt verwijderen?
            </p>
            <form
                onSubmit={async (e) => {
                    e.preventDefault();

                    await handleDeleteEmployee({
                        deleteEmployee,
                        employeeId,
                        idToken: authContext.idToken,
                    });
                }}
            >
                <Checkbox
                    label={"Ja, ik wil mijn account permanent verwijderen"}
                    active={isCheckboxChecked}
                    onClick={() =>
                        dispatch(setIsCheckboxChecked(!isCheckboxChecked))
                    }
                />
                <Button
                    disabled={!isCheckboxChecked || deleteEmployeeIsLoading}
                    loading={deleteEmployeeIsLoading}
                    variant={"alert"}
                    type={"submit"}
                >
                    Account verwijderen
                </Button>
            </form>
        </Popup>
    );
};
